export const buildInfo = {
  buildVersion: "0.5.3",
  buildDate: 1775872790388,
  buildDateStr: "Sat Apr 11 2026 03:59:50 GMT+0200 (Central European Summer Time)"
}